import { type RequestPayload, router } from "@inertiajs/core";
import { ApprenticeSupervisorForm } from "../../../components/apprenticeSupervisor/ApprenticeSupervisorForm";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { ApprenticeSupervisor } from "../../../models/apprenticeSupervisor";
import type { Company } from "../../../models/company";
import { apprentice_supervisor_path, apprentice_supervisors_path } from "../../../routes";

type ApprenticeSupervisorEditProps = {
  apprenticeSupervisor: ApprenticeSupervisor;
  companies: Company[];
};

export default function ApprenticeSupervisorEdit({ apprenticeSupervisor, companies }: ApprenticeSupervisorEditProps) {
  const { pathWithYearContext } = useYearContext();
  const updateApprenticeSupervisor = (values: RequestPayload) =>
    router.patch(pathWithYearContext(apprentice_supervisor_path, apprenticeSupervisor.id), values);

  return (
    <ContentShell
      title={`Berufsbildner/in ${getFullName(apprenticeSupervisor)}`}
      onBack={() => router.get(pathWithYearContext(apprentice_supervisors_path))}
    >
      <ApprenticeSupervisorForm
        apprenticeSupervisor={apprenticeSupervisor}
        submitButtonLabel="Speichern"
        onSubmit={updateApprenticeSupervisor}
        companies={companies}
      />
    </ContentShell>
  );
}
